import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import {
	StyledInput
} from 'lib/styles';

const Container = styled.div`
	margin: 0 0 40px;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Title = props => {
	const { t } = props;

	return (
		<Container>
			<Label>{t('controls/pictogram/title/label')}</Label>
			<StyledInput
				type="text"
				value={props.title}
				onChange={e => props.onChange(e.target.value)}
			/>
		</Container>
	)
}

Title.propTypes = {
	t: PropTypes.func,
	title: PropTypes.string,
	onChange: PropTypes.func,
}

export default translate('translations')(Title)
